/** 打标签 - 任务列表 */
export const getTaskListRequest = "get task list async request";
export const getTaskListSuccess = "get task list async success";
export const getTaskListFailure = "get task list async failure";

/** 打标签 - 打标签人列表 */
export const getSelectListRequest = "get Select list async request";
export const getSelectListSuccess = "get Select list async success";
export const getSelectListFailure = "get Select list async failure";

/** 打标签 - 审核人列表 */
export const getCheckListRequest = "get Check list async request";
export const getCheckListSuccess = "get Check list async success";
export const getCheckListFailure = "get Check list async failure";

/** 打标签 - 类型列表 */
export const getFilterListRequest = "get filter list async request";
export const getFilterListSuccess = "get filter list async success";
export const getFilterListFailure = "get filter list async failure";

export const setStage = "set set tag list stage";


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/actionType.js